import React from "react";
import { Col, Row } from "react-bootstrap";

const Assets = ({ data }) => {
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={12}>
            <h5 className="mb-4">Furniture</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Location:</strong>
              {data?.furniture?.location || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Value:</strong>
              {data?.furniture?.value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Loan Balance:</strong>
              {data?.furniture?.loanbalance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Personal Effects</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Location:</strong>
              {data?.personal_effects?.location || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Value:</strong>
              {data?.personal_effects?.value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Loan Balance:</strong>
              {data?.personal_effects?.loanbalance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Artwork</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Location:</strong>
              {data?.artwork?.location || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Value:</strong>
              {data?.artwork?.value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Loan Balance:</strong>
              {data?.artwork?.loanbalance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Jewellery</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Location:</strong>
              {data?.jewellery?.location || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Value:</strong>
              {data?.jewellery?.value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Loan Balance:</strong>
              {data?.jewellery?.loanbalance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Collections</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Location:</strong>
              {data?.collections?.location || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Value:</strong>
              {data?.collections?.value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Loan Balance:</strong>
              {data?.collections?.loanbalance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Guns</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Location:</strong>
              {data?.guns?.location || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Value:</strong>
              {data?.guns?.value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Loan Balance:</strong>
              {data?.guns?.loanbalance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Coins</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Location:</strong>
              {data?.coins?.location || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Value:</strong>
              {data?.coins?.value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Loan Balance:</strong>
              {data?.coins?.loanbalance || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Antiques</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Location:</strong>
              {data?.antiques?.location || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Value:</strong>
              {data?.antiques?.value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Loan Balance:</strong>
              {data?.antiques?.loanbalance || "--"}
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default Assets;
